module.exports = __webpack_public_path__ + "assets/b94.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b94.png
// module id = 687
// module chunks = 0